import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

export const setSetting = makeBusyFunction(setSettingWithoutBusy, "Updating setting", undefined, 0)

export async function setSettingWithoutBusy(settingValue) {
    return mutate(
        gql`
            mutation setSettingValue($settingValue: JSONObject!) {
                setSettingValue(settingValue: $settingValue)
            }
        `,
        { settingValue },
        { returns: "setting" }
    )
}
